import { render, staticRenderFns } from "./videoInfo.vue?vue&type=template&id=2822e4d5&scoped=true"
import script from "./videoInfo.vue?vue&type=script&lang=js"
export * from "./videoInfo.vue?vue&type=script&lang=js"
import style0 from "./videoInfo.vue?vue&type=style&index=0&id=2822e4d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2822e4d5",
  null
  
)

export default component.exports